export const loadingFoldersSelector = state => state.documentReducer.loadingFolders;

export const foldersSelector = state => state.documentReducer.folders;

export const loadingDocumentsSelector = state => state.documentReducer.loadingDocuments;

export const documentsSelector = state => state.documentReducer.documents;
